import { ApiClient, ApiClientConfig } from "../api-client";
import { ApiClientError } from "../errors";
import schemaValidators from "./schema-validators";
import { AssessmentInfo } from "../types";

export default class startAssessmentClient extends ApiClient<typeof schemaValidators> {
	constructor(config: ApiClientConfig) {
		super(config, schemaValidators);
	}

	check = async (data: {
		assessmentInfo: AssessmentInfo;
		os: string;
		chromeVersion: string;
		extensionVersion: string;
		lmsUserInfo?: {
			email?: string;
			name?: string;
		};
		isManagedGuestSession?: boolean;
	}): Promise<{ eligible: boolean; exempted: boolean; error?: string | undefined }> => {
		try {
			const response = await super.fetch(new URL(`/api/verity/quiz/take/check`, this.config.verityOrigin), {
				method: "POST",
				credentials: "include",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					data,
				}),
			});
			if (response.ok) {
				const responseData = await response.json();
				if (this.schemaValidators.checkUserAndAuthenticateResponse.validate(responseData)) {
					return responseData;
				}
			}
		} catch (error) {
			if (error instanceof Error) {
				throw new ApiClientError(error);
			}
		}
		throw new ApiClientError();
	};

	start = async (assessmentInfo: AssessmentInfo) => {
		try {
			const response = await super.fetch(new URL(`/api/verity/quiz/take/check`, this.config.verityOrigin), {
				method: "POST",
				credentials: "include",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					assessmentInfo,
				}),
			});
			if (response.ok) {
				const responseData = await response.json();
				if (this.schemaValidators.checkUserAndAuthenticateResponse.validate(responseData)) {
					return responseData;
				}
			}
		} catch (error) {
			if (error instanceof Error) {
				throw new ApiClientError(error);
			}
		}
		throw new ApiClientError();
	};
}
